
// ── Core utilities ──
function fmtMoney(v){return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(v||0)}
function escapeHtml(s){if(s==null)return '';return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;')}
// Adia a chamada até `ms` sem nova invocação — usado nas buscas das telas com
// coleções grandes (pedidos, OS, produção, estoque), onde render() a cada
// tecla refaz clones JSON de arrays de milhares de itens e trava a digitação.
function debounce(fn,ms=200){let t;return function(...args){clearTimeout(t);t=setTimeout(()=>fn.apply(this,args),ms)}}
const debouncedRenderPedidos=debounce(()=>renderPedidos());
const debouncedRenderProducao=debounce(()=>renderProducao());
const debouncedRenderOS=debounce(()=>renderOS());
const debouncedRenderEstoque=debounce(()=>renderEstoque());
function tituloCase(s){const minusculas=new Set(['de','da','do','das','dos','e']);return String(s||'').toLowerCase().split(' ').filter(Boolean).map((w,i)=>minusculas.has(w)&&i>0?w:w.charAt(0).toUpperCase()+w.slice(1)).join(' ')}
function nomeAssinaturaAbreviado(s){const partes=tituloCase(s).split(' ').filter(Boolean);if(partes.length<=2)return partes.join(' ');return[partes[0],...partes.slice(1,-1).map(p=>p.charAt(0)+'.'),partes[partes.length-1]].join(' ')}
function whatsappNumber(tel){
  let digits=String(tel||'').replace(/\D/g,'').replace(/^0+/,'');
  if(digits.length===10||digits.length===11) digits='55'+digits;
  return digits;
}
function quickContactLinks(tel,email,compact=false){
  const phone=whatsappNumber(tel),mail=String(email||'').trim();
  if(!phone&&!mail) return '';
  return `<div class="quick-actions${compact?' compact':''}">
    ${phone?`<a class="quick-link whatsapp" href="https://wa.me/${phone}" target="_blank" rel="noopener" onclick="event.stopPropagation()" title="Conversar pelo WhatsApp">◉ WhatsApp</a>`:''}
    ${mail?`<a class="quick-link email" href="mailto:${encodeURIComponent(mail)}" onclick="event.stopPropagation()" title="Abrir no aplicativo de e-mail padrão">✉ E-mail</a>`:''}
  </div>`;
}
